export const safeSetItem = (key: string, value: string) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    localStorage.setItem(key, value);
  } catch (e: any) {
    if (
      e?.name === 'QuotaExceededError' ||
      e?.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
      e?.code === 22
    ) {
      try {
        Object.keys(localStorage).forEach((k) => {
          if (k.startsWith('cache_') || k.includes('_page_')) {
            localStorage.removeItem(k);
          }
        });
        localStorage.setItem(key, value);
      } catch (retryError) {
        console.error('Retry failed after clearing localStorage:', retryError);
      }
    } else {
      console.error('Unexpected localStorage error:', e);
    }
  }
};
